import React from "react";

export const getLogoText = () => {
    return (
      <>Virtual<span style={{ fontWeight: "bold" }}>Care</span></>
    )
};